module.exports = __webpack_public_path__ + "Player2Wins.mp3";